import React, { createContext, useContext, useState, useEffect } from 'react';
import { API_BASE_URL } from '../assets/js/scripts/control';

const AdminAuthContext = createContext();

export const AdminAuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [role, setRole] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loggedIn = localStorage.getItem('loggedIn');
    const savedRole = localStorage.getItem('role');
    if (loggedIn !== 'true' || !savedRole) return;

    fetch(`${API_BASE_URL}/api/check_session.php`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        if (data.loggedIn) {
          setIsLoggedIn(true);
          setRole(data.role);
          setIsAdmin(data.role === 'admin');
        } else {
          localStorage.removeItem('loggedIn');
          localStorage.removeItem('role');
        }
      })
      .catch(() => {
        setIsLoggedIn(true);
        setRole(savedRole);
        setIsAdmin(savedRole === 'admin');
      });
  }, []);

  const login = (userDataOrRole) => {
    setIsLoggedIn(true);
    if (typeof userDataOrRole === 'object' && userDataOrRole !== null) {
      setUser(userDataOrRole);
      setRole(userDataOrRole.role);
      setIsAdmin(userDataOrRole.role === 'admin');
    } else {
      // Caso en el que se recibe solo el rol
      setRole(userDataOrRole);
      setIsAdmin(userDataOrRole === 'admin');
    }
  };

  const logout = () => {
    setIsLoggedIn(false);
    setRole(null);
    setUser(null);
    setIsAdmin(false);
    localStorage.removeItem('loggedIn');
    localStorage.removeItem('role');
  };

  return (
    <AdminAuthContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        isAdmin,
        setIsAdmin,
        role,
        setRole,
        user,
        login,
        logout,
      }}
    >
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
